import {
  Form,
  Input,
  InputNumber,
  Select,
  Switch,
  // DatePicker,
  Row,
  Col,
} from "antd";

const { Option } = Select;

export default function HostForm({ form, disabled = false }) {
  return (
    <Form form={form} layout="vertical">
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item
            label="房号"
            name="roomNumber"
            rules={[{ required: true }]}
          >
            <Input disabled={disabled} />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label="楼栋名称" name="buildingName">
            <Input disabled={disabled} />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label="楼栋号" name="buildingNumber">
            <InputNumber disabled={disabled} style={{ width: "100%" }} />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label="楼层" name="floorNumber">
            <InputNumber disabled={disabled} style={{ width: "100%" }} />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label="总楼层" name="totalFloors">
            <InputNumber disabled={disabled} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="面积" name="area">
            <InputNumber disabled={disabled} style={{ width: "100%" }} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="户型" name="roomType">
            <Select disabled={disabled} allowClear>
              <Option value="single">单间</Option>
              <Option value="bedAndLiving">一室一厅</Option>
              <Option value="twoBedRooms">两居</Option>
              <Option value="threeBedRooms">三居</Option>
              <Option value="duplex">复式</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="是否有效" name="valid" valuePropName="checked">
            <Switch disabled={disabled} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="出租情况" name="status">
            <Select disabled={disabled} allowClear>
              <Option value="daily">日租</Option>
              <Option value="monthly">月租</Option>
              <Option value="quarterly">季租</Option>
              <Option value="yearly">年租</Option>
              <Option value="empty">空置</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="备注" name="description">
        <Input.TextArea rows={3} disabled={disabled} />
      </Form.Item>
    </Form>
  );
}
